// Généré automatiquement (traduction LLM FR→ES) — complète es.js. Ne pas éditer à la main.
export const AUTO_DICT = {
 "% (pourcentage)": "% (porcentaje)",
 "% du total HT": "% del total HT",
 "% due et déductible simultanément (neutre).": "% exigible y deducible simultáneamente (neutral).",
 "%) est due et déductible simultanément (neutre, requis pour la CA3).": "%) es exigible y deducible simultáneamente (neutral, requerido para la CA3).",
 "(+ snapshot)": "(+ instantánea)",
 "(Dr ↔ Cr inversés) sans toucher à l'originale. Idéal pour annuler une écriture FEC verrouillée sans casser l'audit trail.": "(Dr ↔ Cr invertidos) sin tocar la original. Ideal para anular un asiento FEC bloqueado sin romper el audit trail.",
 "(Gmail n'accepte plus le mot de passe principal depuis 2022).": "(Gmail ya no acepta la contraseña principal desde 2022).",
 "(Mail → 16 caractères)": "(Mail → 16 caracteres)",
 "(Qonto importée)": "(Qonto importada)",
 "(Qonto, Stripe, imports CSV), leurs ventilations et justificatifs.": "(Qonto, Stripe, importaciones CSV), sus distribuciones y justificantes.",
 "(Restricted key avec accès lecture sur \"Payment Intents\" et \"Charges\" suffit).": "(Basta con una clave restringida con acceso de lectura a \"Payment Intents\" y \"Charges\").",
 "(ancien remplacé)": "(anterior reemplazado)",
 "(aucun timeout possible). Vos": "(sin posibilidad de timeout). Sus",
 "(bénéfice → Cr 120000)": "(beneficio → Cr 120000)",
 "(charges identifiées). Les transactions non-classées peuvent être ignorées ou parkées en 471 (compte d'attente).": "(cargos identificados). Las transacciones no clasificadas pueden ignorarse o aparcarse en 471 (cuenta de espera).",
 "(correction HT/TVA Qonto)": "(corrección HT/TVA Qonto)",
 "(défini)": "(definido)",
 "(entrantes) des 2 dernières années sur tous vos comptes Qonto.": "(entrantes) de los 2 últimos años en todas sus cuentas Qonto.",
 "(exercice courant — identique à la Balance)": "(ejercicio actual — idéntico al Balance)",
 "(extraction et comparaison automatiques)": "(extracción y comparación automáticas)",
 "(le CA est celui des encaissements bancaires, comme dans Comptalib), vous pouvez": "(el CA es el de los cobros bancarios, como en Comptalib), puede",
 "(nul)": "(nulo)",
 "(patients avec `is_business=true`) continuent de générer un Factur-X classique.": "(los pacientes con `is_business=true`) siguen generando un Factur-X clásico.",
 "(perte → Dr 129000)": "(pérdida → Dr 129000)",
 "(perte)": "(pérdida)",
 "(résout le doublon CA)": "(resuelve el duplicado de CA)",
 "(toute l'historique). Renseignez 2027-09-01 (ou plus tôt selon votre choix) pour la production.": "(todo el historial). Indique 2027-09-01 (o una fecha anterior, según su elección) para la producción.",
 "(validée)": "(validada)",
 "(whsec_...) dans le champ ci-dessus.": "(whsec_...) en el campo de arriba.",
 "(à-nouveaux)": "(a nuevos)",
 "+ Ajouter depuis le catalogue…": "+ Añadir desde el catálogo…",
 "+ Frais bancaires": "+ Gastos bancarios",
 "+ Vente": "+ Venta",
 "-Moins-value": "-Minusvalía",
 ". Choisissez la portée :": ". Elija el alcance:",
 ". Cochez « Remplacer » ci-dessous pour la refaire.": ". Marque « Reemplazar » a continuación para volver a hacerlo.",
 ". Copiez le": ". Copie el",
 ". Encaissez une facture en « Espèces » ou ajoutez un mouvement.": ". Cobrar una factura en «Efectivo» o añadir un movimiento.",
 ". Le CA sera alors calculé uniquement à partir des BQ (encaissements).": ". El CA se calculará entonces únicamente a partir de las BQ (cobros).",
 ". Pour corriger, créez un avoir.": ". Para corregirlo, cree un abono.",
 ". Synchronisez ou attendez un webhook.": ". Sincronice o espere un webhook.",
 "0 ? \"L'entreprise doit à l'associé\" : a.balance": "0 ? \"La empresa debe al socio\" : a.balance",
 "AN aperçu": "vista previa AN",
 "AN aperçu vs balance de clôture Comptalib (fenêtre": "vista previa AN frente al balance de cierre de Comptalib (ventana",
 "AN datés en milieu de fenêtre exclus du calcul (leur contenu est déjà présent dans les écritures brutes) — anti double comptage": "AN fechados en mitad de la ventana excluidos del cálculo (su contenido ya está presente en los asientos brutos) — antideduplicación",
 "AN importé Comptalib": "AN importado Comptalib",
 "AN intermédiaire(s) exclu(s)": "AN intermedio(s) excluido(s)",
 "API Key (JWT)": "Clave API (JWT)",
 "Abonner le webhook automatiquement": "Suscribir el webhook automáticamente",
 "Acheteur (libellé)": "Comprador (etiqueta)",
 "Acquisition": "Adquisición",
 "Actif + Archivé": "Activo + Archivado",
 "Actif circulant": "Activo circulante",
 "Actif immobilisé": "Activo inmovilizado",
 "Action": "Acción",
 "Active la génération de rapports B2C dans le menu E-reporting.": "Activa la generación de informes B2C en el menú E-reporting.",
 "Activer la planification nocturne": "Activar la programación nocturna",
 "Activez la": "Active la",
 "Activez pour accorder un tarif préférentiel (étudiant, tarif négocié…)": "Actívelo para conceder una tarifa preferencial (estudiante, tarifa negociada…)",
 "Activité récente": "Actividad reciente",
 "Actualiser": "Actualizar",
 "Actuelle :": "Actual:",
 "Affecter le résultat": "Asignar el resultado",
 "Ajouter un justificatif": "Añadir un justificante",
 "Ajouter une ligne": "Añadir una línea",
 "Amort. & prov.": "Amort. y provisiones",
 "Amortissement cumulé estimé :": "Amortización acumulada estimada:",
 "Analyse de l'écart Qonto / comptabilité": "Análisis de la diferencia Qonto / contabilidad",
 "Analyse du FEC en cours…": "Análisis del FEC en curso…",
 "Analyse en cours (interrogation Qonto)…": "Análisis en curso (consulta a Qonto)…",
 "Analyser l'écart": "Analizar la diferencia",
 "Analyser les non-catégorisées": "Analizar las no categorizadas",
 "Analyse…": "Analizando…",
 "Annoter la sélection": "Anotar la selección",
 "Aperçu PDF": "Vista previa PDF",
 "Appliquée au titre « Facture », à l'en-tête du tableau et au cadre TTC dans le PDF.": "Aplicada al título «Factura», al encabezado de la tabla y al marco TTC en el PDF.",
 "Appliquées aux transactions Qonto pour générer les écritures BQ avec le bon compte de charge.": "Aplicadas a las transacciones de Qonto para generar los asientos BQ con la cuenta de gasto correcta.",
 "Apport (l'associé apporte)": "Aportación (el socio aporta)",
 "Archiver les doublons VE": "Archivar los duplicados VE",
 "Archivé · source": "Archivado · origen",
 "Associez vos transactions bancaires (Finom, Qonto) et vos paiements en ligne (Stripe) aux factures. Le rapprochement crée automatiquement un paiement et marque la facture acquittée.": "Asocie sus transacciones bancarias (Finom, Qonto) y sus pagos en línea (Stripe) a las facturas. La conciliación crea automáticamente un pago y marca la factura como pagada.",
 "Attache le PDF de facture à toutes les transactions Qonto rapprochées qui n'ont pas encore leur justificatif côté Qonto": "Adjunta el PDF de la factura a todas las transacciones Qonto conciliadas que aún no tienen su justificante en Qonto",
 "Attacher": "Adjuntar",
 "Attacher factures → Qonto": "Adjuntar facturas → Qonto",
 "Attacher les factures rapprochées": "Adjuntar las facturas conciliadas",
 "Attaché": "Adjuntado",
 "Au moins 2 exercices sont nécessaires": "Se necesitan al menos 2 ejercicios",
 "Aucun associé configuré.": "Ningún socio configurado.",
 "Aucun candidat détecté. Soit toutes les immobilisations sont déjà créées, soit votre FEC ne contient pas d'écritures sur les comptes 28xxxx.": "No se ha detectado ningún candidato. O bien ya están creadas todas las inmovilizaciones, o su FEC no contiene apuntes en las cuentas 28xxxx.",
 "Aucun cas détecté": "No se ha detectado ningún caso",
 "Aucun compte. Importez un FEC ou créez-en un.": "Ninguna cuenta. Importe un FEC o cree una.",
 "Aucun compte. Tapez un autre mot-clé ou créez un compte personnalisé.": "Ninguna cuenta. Escriba otra palabra clave o cree una cuenta personalizada.",
 "Aucun exercice. Importez un FEC pour commencer.": "Ningún ejercicio. Importe un FEC para empezar.",
 "Aucun justificatif": "Ningún justificante",
 "Aucun mouvement de caisse en": "Ningún movimiento de caja en",
 "Aucun paiement enregistré sur la période": "No hay ningún pago registrado en el período",
 "Aucun paiement.": "Ningún pago.",
 "Aucun patient n'est créé automatiquement : la recherche prioritaire par e-mail / téléphone vous est proposée avant toute création.": "No se crea automáticamente ningún paciente: se le propone una búsqueda prioritaria por correo electrónico / teléfono antes de cualquier creación.",
 "Aucun patient trouvé": "No se ha encontrado ningún paciente",
 "Aucun patient.": "Ningún paciente.",
 "Aucun rapport. Générez votre premier rapport ci-dessus.": "Ningún informe. Genere su primer informe arriba.",
 "Aucun rendez-vous ce jour": "No hay citas hoy",
 "Aucun rendez-vous. Cliquez sur Synchroniser.": "No hay citas. Haga clic en Sincronizar.",
 "Aucun service. Cliquez sur « Nouveau service ».": "Ningún servicio. Haga clic en «Nuevo servicio».",
 "Aucun type d'événement détecté. Synchronisez d'abord vos rendez-vous Calendly.": "No se ha detectado ningún tipo de evento. Sincronice primero sus citas de Calendly.",
 "Aucune anomalie détectée : Qonto et la comptabilité sont alignés.": "No se ha detectado ninguna anomalía: Qonto y la contabilidad están alineados.",
 "Aucune donnée pour l'instant.": "No hay datos por ahora.",
 "Aucune donnée. Générez des écritures VE / BQ.": "No hay datos. Genere asientos VE / BQ.",
 "Aucune en attente.": "No hay ninguna pendiente.",
 "Aucune entrée.": "Ninguna entrada.",
 "Aucune facture du même montant.": "Ninguna factura del mismo importe.",
 "Aucune facture dupliquée": "Ninguna factura duplicada",
 "Aucune facture impayée datée autour de cette transaction. Utilisez la recherche ci-dessus.": "No hay ninguna factura impagada fechada alrededor de esta transacción. Utilice la búsqueda de arriba.",
 "Aucune facture pour ces filtres.": "No hay facturas para estos filtros.",
 "Aucune facture pour l'instant.": "No hay facturas por ahora.",
 "Aucune facture trouvée.": "No se ha encontrado ninguna factura.",
 "Aucune facture trouvée. Tapez un terme de recherche.": "No se ha encontrado ninguna factura. Escriba un término de búsqueda.",
 "Aucune facture.": "Ninguna factura.",
 "Aucune immobilisation. Cliquez sur « Nouvelle immobilisation ».": "Ninguna inmovilización. Haga clic en «Nueva inmovilización».",
 "Aucune ligne": "No hay ninguna línea",
 "Aucune règle ne matche. La transaction irait en compte d'attente": "Ninguna regla coincide. La transacción iría a una cuenta transitoria",
 "Aucune règle. Cliquez « Charger règles par défaut ».": "Ninguna regla. Haz clic en «Cargar reglas predeterminadas».",
 "Aucune séquence définie.": "No se ha definido ninguna secuencia.",
 "Aucune transaction ne correspond à ce filtre.": "Ninguna transacción coincide con este filtro.",
 "Aucune transaction.": "Ninguna transacción.",
 "Aucune écriture VE dupliquée": "Ningún asiento VE duplicado",
 "Aucune écriture VE illégitime détectée (cutoff :": "No se ha detectado ningún asiento VE ilegítimo (cutoff :",
 "Aucune écriture pour ce compte.": "No hay asientos para esta cuenta.",
 "Aucune écriture sur cet exercice.": "No hay asientos en este ejercicio.",
 "Audit du chiffre d'affaires": "Auditoría de la cifra de negocios",
 "Auditer mon CA": "Auditar mi CA",
 "Autoliquidation": "Autoliquidación",
 "Autoliquidation : le montant payé est traité comme HT, la TVA (": "Autoliquidación: el importe pagado se trata como HT, la TVA (",
 "Autre": "Otro",
 "Autres": "Otros",
 "Autres créances": "Otros créditos",
 "Autres factures (validées et payées)": "Otras facturas (validadas y pagadas)",
 "BASIC WL — En-tête + identité acheteur (sans lignes)": "BASIC WL — Cabecera + identidad del comprador (sin líneas)",
 "BASIC — Avec lignes de facture détaillées": "BASIC — Con líneas de factura detalladas",
 "BQ (annotations)": "BQ (anotaciones)",
 "BQ créées` + (gen.bq_uncategorized ? ` · $": "BQ creadas` + (gen.bq_uncategorized ? ` · $",
 "Backfill appliqué": "Rellenado retrospectivo aplicado",
 "Banque :": "Banco :",
 "Banques (Finom / Qonto)": "Bancos (Finom / Qonto)",
 "Bimensuelle (2x/mois)": "Bimensual (2 veces/mes)",
 "Bloc de mentions légales en bas du PDF (bio, affiliations, complémentaires santé…)": "Bloque de menciones legales en la parte inferior del PDF (bio, afiliaciones, seguros complementarios de salud…)",
 "Bloque la création de factures pour les rendez-vous Calendly antérieurs ou égaux à cette date (utile si les RDV plus anciens ont déjà été facturés via Qonto ou un autre outil). Laissez vide pour ne rien verrouiller.": "Bloque la creación de facturas para las citas de Calendly anteriores o iguales a esta fecha (útil si las citas más antiguas ya se han facturado a través de Qonto u otra herramienta). Déjalo vacío para no bloquear nada.",
 "Brouillons": "Borradores",
 "Brut": "Bruto",
 "CA (70x) · Sorties = dépenses réelles (60-67, hors dotations 68x et impôts de clôture 69x) · Trésorerie cumulée (classe 5)": "CA (70x) · Salidas = gastos reales (60-67, excluidas las dotaciones 68x y los impuestos de cierre 69x) · Tesorería acumulada (clase 5)",
 "CA en trop": "CA en exceso",
 "CA mensuel par source (7xxx, HT) vs factures émises (TTC)": "CA mensual por fuente (7xxx, HT) vs facturas emitidas (TTC)",
 "CA total (comptes 7)": "CA total (cuentas 7)",
 "Caisse (5300)": "Caja (5300)",
 "Calcul…": "Calculando…",
 "Calendly — Clé signature webhook (auto-rempli)": "Calendly — Clave de firma del webhook (autorrellenada)",
 "Calendly — Organisation URI (auto-rempli)": "Calendly — URI de la organización (autorrellenada)",
 "Calendly — Token Personal Access": "Calendly — Token de acceso personal",
 "Calendly — User URI (auto-rempli)": "Calendly — URI del usuario (autorrellenada)",
 "Calendly ↔ Services": "Calendly ↔ Servicios",
 "Cas suspects": "Casos sospechosos",
 "Catalogue → Service → Comptabilité": "Catálogo → Servicio → Contabilidad",
 "Catégorie": "Categoría",
 "Catégorie (compte PCG)": "Categoría (cuenta PCG)",
 "Catégoriser": "Categorizar",
 "Catégoriser la transaction": "Categorizar la transacción",
 "Catégorisées (manuelles)": "Categorizadas (manuales)",
 "Centralisation des factures EURL, patients, paiements et rapprochements bancaires — indépendamment de vos banques et prestataires.": "Centralización de facturas EURL, pacientes, pagos y conciliaciones bancarias, independientemente de tus bancos y proveedores.",
 "Centralisez les factures Qonto importées et celles créées dans l'outil. Les factures validées sont immuables.": "Centralice las facturas Qonto importadas y las creadas en la herramienta. Las facturas validadas son inmutables.",
 "Certaines factures Qonto importées avant le fix d'import ont": "Algunas facturas de Qonto importadas antes de la corrección de importación han",
 "Ces factures sont validées": "Estas facturas están validadas",
 "Cession": "Cesión",
 "Cette facture a été annulée par un avoir.": "Esta factura ha sido anulada mediante un abono.",
 "Cette facture est validée": "Esta factura está validada",
 "Cette transaction est figée par l'import FEC. Déliez-la pour recatégoriser.": "Esta transacción está bloqueada por la importación FEC. Desvincúlala para recategorizarla.",
 "Cette écriture solde le compte 120 (résultat) et le répartit entre réserves, report à nouveau et dividendes.": "Este asiento salda la cuenta 120 (resultado) y la distribuye entre reservas, remanente y dividendos.",
 "Chargement du dashboard de clôture…": "Cargando el panel de cierre…",
 "Charger règles par défaut": "Cargar reglas predeterminadas",
 "Charges constatées d'avance": "Gastos anticipados",
 "Choisir un fichier CSV": "Elegir un archivo CSV",
 "Choisir un fichier FEC": "Elegir un archivo FEC",
 "Client professionnel (B2B — pour Factur-X / facturation électronique)": "Cliente profesional (B2B — para Factur-X / facturación electrónica)",
 "Client professionnel (B2B)": "Cliente profesional (B2B)",
 "Clé / patient": "Clave / paciente",
 "Clôture prévue le": "Cierre previsto el",
 "Clôturer": "Cerrar",
 "Clôturer immédiatement (ValidDate posée, écritures immuables)": "Cerrar inmediatamente (ValidDate establecida, asientos inmutables)",
 "Clôturé": "Cerrado",
 "Cochez les événements": "Marque los eventos",
 "Code APE": "Código APE",
 "Collez la balance Comptalib (copier-coller du PDF ou CSV) — comparaison des soldes nets sur": "Pegue el balance Comptalib (copiar y pegar desde PDF o CSV) — comparación de los saldos netos sobre",
 "Collez-les dans « Mot de passe SMTP » ci-dessous": "Péguelos en « Mot de passe SMTP » a continuación",
 "Colonnes attendues : date, label/description, counterparty, amount, currency, reference. Ces transactions seront proposées au rapprochement avec vos factures.": "Columnas esperadas : date, label/description, counterparty, amount, currency, reference. Estas transacciones se propondrán para su conciliación con sus facturas.",
 "Comment ça marche :": "Cómo funciona:",
 "Commentaire": "Comentario",
 "Comparaison AN généré vs": "Comparación de AN generado vs",
 "Comparaison…": "Comparación…",
 "Comparer": "Comparar",
 "Comparer au PDF Comptalib": "Comparar con el PDF de Comptalib",
 "Comparer avec Comptalib": "Comparar con Comptalib",
 "Compléter les invités manquants": "Completar los invitados que faltan",
 "Compta 512x": "Contabilidad 512x",
 "Comptabilisation…": "Contabilización…",
 "Comptabiliser": "Contabilizar",
 "Comptabilité (PCG) — utilisé pour la génération automatique d'écritures VE": "Contabilidad (PCG) — utilizado para la generación automática de asientos VE",
 "Compte (préfixe)": "Cuenta (prefijo)",
 "Compte 5300 · journal CA · chaque mouvement crée immédiatement son écriture": "Cuenta 5300 · libro diario CA · cada movimiento crea inmediatamente su asiento",
 "Compte PCG": "Cuenta PCG",
 "Compte PCG (": "Cuenta PCG (",
 "Compte TVA collectée": "Cuenta de TVA repercutida",
 "Compte TVA déductible": "Cuenta de TVA deducible",
 "Compte amortissements (28x)": "Cuenta de amortizaciones (28x)",
 "Compte de charge (6xxx)": "Cuenta de gasto (6xxx)",
 "Compte de contrepartie": "Cuenta de contrapartida",
 "Compte dotation (681x)": "Cuenta de dotación (681x)",
 "Compte immobilisation": "Cuenta de inmovilizado",
 "Compte produit (707/706…)": "Cuenta de producto (707/706…)",
 "Compte suggéré": "Cuenta sugerida",
 "Comptes": "Cuentas",
 "Comptes courants associés": "Cuentas corrientes asociadas",
 "Configure le e-reporting des transactions B2C (patients particuliers) à transmettre périodiquement au PPF. Vos factures": "Configura el e-reporting de las transacciones B2C (pacientes particulares) que se transmitirán periódicamente al PPF. Sus facturas",
 "Configurer cet associé": "Configurar este asociado",
 "Confirmer la cession": "Confirmar la cesión",
 "Confirmer le rebut": "Confirmar el desecho",
 "Connexion en cours…": "Conexión en curso…",
 "Conseils": "Consejos",
 "Contre-passer une écriture": "Revertir un asiento",
 "Contrepartie": "Contrapartida",
 "Contrepartie / libellé": "Contrapartida / concepto",
 "Conversion appliquée": "Conversión aplicada",
 "Conversion…": "Conversión…",
 "Convertir les annotations 7xx → 411000": "Convertir las anotaciones 7xx → 411000",
 "Convertit les transactions Qonto en écritures du journal Banque. Les crédits rapprochés à des factures sont lettrés automatiquement avec les VE correspondantes. Les débits sont catégorisés via les": "Convierte las transacciones de Qonto en asientos del libro diario Banco. Los créditos conciliados con facturas se compensan automáticamente con las VE correspondientes. Los débitos se categorizan mediante los",
 "Coordonnées": "Datos de contacto",
 "Corps relance": "Cuerpo del recordatorio",
 "Correspondance exacte (1 facture)": "Coincidencia exacta (1 factura)",
 "Correspondances suggérées": "Coincidencias sugeridas",
 "Couleur principale (hex)": "Color principal (hex)",
 "Couple (": "Par (",
 "Cron nocturne :": "Cron nocturno:",
 "Créances clients et comptes rattachés": "Créditos de clientes y cuentas vinculadas",
 "Création…": "Creación…",
 "Crédit (entrée)": "Crédito (entrada)",
 "Crédits": "Créditos",
 "Crédits (allocations)": "Créditos (asignaciones)",
 "Crée une écriture": "Crear un asiento",
 "Créer l'AN": "Crear la AN",
 "Créer l'écriture": "Crear el asiento",
 "Créer la contre-passation": "Crear el asiento de reversión",
 "Créer le patient": "Crear el paciente",
 "Créer quand même": "Crear de todos modos",
 "Créer un avoir": "Crear una factura rectificativa",
 "Créer un exercice exceptionnel": "Crear un ejercicio excepcional",
 "Créer un nouveau patient": "Crear un nuevo paciente",
 "Créer une règle": "Crear una regla",
 "Créer votre premier associé": "Crear tu primer socio",
 "Cumul amort.": "Amort. acumulada",
 "Céder / Mettre au rebut": "Ceder / Dar de baja",
 "Cédé": "Cedido",
 "Dans Gmail → ⚙️ Paramètres → Comptes →": "En Gmail → ⚙️ Ajustes → Cuentas →",
 "Date d'acquisition": "Fecha de adquisición",
 "Date d'acquisition manquante : cliquez sur ✏️ pour la renseigner et générer le plan.": "Falta la fecha de adquisición: haga clic en ✏️ para indicarla y generar el plan.",
 "Date d'écriture": "Fecha del asiento",
 "Date d'émission": "Fecha de emisión",
 "Date de la contre-passation": "Fecha del asiento de reversión",
 "Date de naissance": "Fecha de nacimiento",
 "Date de verrouillage": "Fecha de bloqueo",
 "Date début": "Fecha de inicio",
 "Date fin (clôture)": "Fecha de fin (cierre)",
 "Date pivot (début du reporting)": "Fecha pivote (inicio del informe)",
 "Date pièce": "Fecha del documento",
 "Dates en ISO (2026-06-01) ou DD/MM/YYYY.": "Fechas en ISO (2026-06-01) o DD/MM/YYYY.",
 "Depuis le": "Desde el",
 "Depuis une facture": "Desde una factura",
 "Dernier RDV": "Última cita",
 "Dernier envoi e-mail :": "Último envío de e-mail:",
 "Dernier n°": "Último n°",
 "Dernier n° utilisé": "Último n° utilizado",
 "Dernière exécution Qonto": "Última ejecución de Qonto",
 "Dernière exécution Relances": "Última ejecución de recordatorios",
 "Dernières factures": "Últimas facturas",
 "Description": "Descripción",
 "Destinataire": "Destinatario",
 "Dettes": "Deudas",
 "Deux écritures AN sont actives pour": "Hay dos asientos de AN activos para",
 "Diagnostic": "Diagnóstico",
 "Diagnostic exercice": "Diagnóstico del ejercicio",
 "Différence :": "Diferencia:",
 "Disponibilités": "Disponibilidades",
 "Diviser": "Dividir",
 "Diviser la transaction": "Dividir la transacción",
 "Document associé": "Documento asociado",
 "Doit commencer par 455.": "Debe empezar por 455.",
 "Doit commencer par 5, 6 ou 7. Ex. 512000 (banque), 530000 (caisse).": "Debe empezar por 5, 6 o 7. Ej. 512000 (banco), 530000 (caja).",
 "Doit tendre vers 0 (créances soldées)": "Debe tender a 0 (créditos saldados)",
 "Dot. annuelle": "Dot. anual",
 "Dotation": "Dotación",
 "Double comptabilisation détectée": "Se ha detectado doble contabilización",
 "Doublons": "Duplicados",
 "Doublons VE archivés": "Duplicados VE archivados",
 "Durée": "Duración",
 "Durée (mois)": "Duración (meses)",
 "Durée d'amortissement (mois)": "Duración de amortización (meses)",
 "Débit (sortie)": "Débito (salida)",
 "Débits": "Débitos",
 "Débits (sources)": "Débitos (fuentes)",
 "Début": "Inicio",
 "Décoché (recommandé) : les écritures des exercices clôturés (ex. 2024, 2025) sont préservées.": "Desmarcado (recomendado) : los asientos de los ejercicios cerrados (p. ej. 2024, 2025) se conservan.",
 "Décoché : seules les écritures comptables sont effacées — vos transactions et catégorisations sont conservées. Coché : il faudra re-synchroniser Qonto ensuite.": "Desmarcado : solo se eliminan los asientos contables — sus transacciones y categorizaciones se conservan. Marcado : habrá que resincronizar Qonto después.",
 "Découvrir depuis mes écritures": "Descubrir desde mis asientos",
 "Définissez le dernier numéro émis par année. La prochaine facture validée prendra le numéro suivant.": "Defina el último número emitido por año. La próxima factura validada tomará el número siguiente.",
 "Définissez vos services et tarifs. Ils seront proposés dans une liste déroulante lors de la création de factures.": "Defina sus servicios y tarifas. Se propondrán en una lista desplegable al crear facturas.",
 "Déjà converties": "Ya convertidas",
 "Déjà en base par ID Qonto :": "Ya en base por ID Qonto :",
 "Déjà en base par n° de facture :": "Ya en base por n° de factura :",
 "Déjà existantes": "Ya existentes",
 "Délier": "Desvincular",
 "Déposer le PDF de balance Comptalib": "Subir el PDF de balance Comptalib",
 "Désactiver": "Desactivar",
 "Détail compte": "Detalle de cuenta",
 "Détail de la facture": "Detalle de la factura",
 "Détecte les cas de double comptabilisation : transactions bancaires rapprochées à une facture ET avec une division sur un compte 7xxx (revenu compté 2x).": "Detecta los casos de doble contabilización: transacciones bancarias conciliadas con una factura Y con un reparto en una cuenta 7xxx (ingreso contabilizado 2x).",
 "Détecter et nettoyer les factures dont la date d'émission est aberrante (vide, antérieure à 2020 ou postérieure à": "Detectar y limpiar las facturas cuya fecha de emisión sea anómala (vacía, anterior a 2020 o posterior a",
 "Détecter et supprimer les dotations générées en double avec votre FEC": "Detectar y eliminar las amortizaciones generadas en doble con su FEC",
 "Détection automatique des immobilisations à partir des écritures du FEC (acquisitions classe 2 + dotations 681xxx / 281xxx). Ajustez la": "Detección automática de inmovilizados a partir de los asientos del FEC (adquisiciones clase 2 + dotaciones 681xxx / 281xxx). Ajuste la",
 "Détection automatique à partir des écritures REV (dotations) et classe 2 (acquisitions).": "Detección automática a partir de los asientos REV (dotaciones) y clase 2 (adquisiciones).",
 "Détecté :": "Detectado :",
 "E-reporting activé": "E-reporting activado",
 "EFFACER": "BORRAR",
 "EN 16931 — Profil européen complet": "EN 16931 — Perfil europeo completo",
 "Effacer aussi les transactions bancaires": "Eliminar también las transacciones bancarias",
 "Effacer définitivement": "Borrar definitivamente",
 "Email": "Correo electrónico",
 "Email :": "Correo electrónico :",
 "En attente d'annotation": "Pendiente de anotación",
 "Encodage UTF-8 recommandé (les BOM sont pris en charge).": "Se recomienda la codificación UTF-8 (los BOM son compatibles).",
 "Enregistrement…": "Registro…",
 "Enregistrer un paiement": "Registrar un pago",
 "Entité": "Entidad",
 "Entrée": "Entrada",
 "Entrées": "Entradas",
 "Envoi en cours…": "Envío en curso…",
 "Envoi…": "Envío…",
 "Envoyer la facture par e-mail": "Enviar la factura por correo electrónico",
 "Envoyer un test": "Enviar una prueba",
 "Erreur Qonto HTTP": "Error HTTP de Qonto",
 "Et mettez l'": "Y ponga el'",
 "Ex : Séance de TCC adultes": "Ej.: Sesión de TCC para adultos",
 "Ex. Encaissement client STRIPE…": "Ej. Cobro de cliente STRIPE…",
 "Ex. Fournitures papeterie": "Ej. Suministros de papelería",
 "Ex: Cabinet du Dr. Martin SARL": "Ej.: Consulta del Dr. Martin SARL",
 "Exceptionnel": "Excepcional",
 "Exemple (une ligne par compte) :\n706004 Ventes de prest. de services TVA 20% 175,00 30 973,71 -30 798,71\n5120 Banque 61 934,34 20 930,39 41 003,95": "Ejemplo (una línea por cuenta) :\n706004 Ventas de prest. de servicios TVA 20% 175,00 30 973,71 -30 798,71\n5120 Banco 61 934,34 20 930,39 41 003,95",
 "Exercice": "Ejercicio",
 "Exercice :": "Ejercicio :",
 "Exercice N": "Ejercicio N",
 "Exercice cible (conservé)": "Ejercicio objetivo (conservado)",
 "Exercice clôturé (FEC) :": "Ejercicio cerrado (FEC) :",
 "Exercice exceptionnel…": "Ejercicio excepcional…",
 "Exercice source :": "Ejercicio origen :",
 "Exercice à ouvrir": "Ejercicio a abrir",
 "Exercices": "Ejercicios",
 "Exercices à fusionner": "Ejercicios a fusionar",
 "Export": "Exportar",
 "Exporter FEC": "Exportar FEC",
 "FEC (Comptalib) sera$": "FEC (Comptalib) será$",
 "Facturation 1-clic :": "Facturación 1 clic :",
 "Facturation électronique (Factur-X)": "Facturación electrónica (Factur-X)",
 "Facture": "Factura",
 "Facture / libellé": "Factura / concepto",
 "Facture Qonto importée": "Factura Qonto importada",
 "Facture acquittée": "Factura pagada",
 "Facture d'origine": "Factura original",
 "Facture liée": "Factura vinculada",
 "Facture validée — non annulable. Créez un avoir pour l'annuler.": "Factura validada — no anulable. Cree una factura rectificativa para anularla.",
 "Facturer": "Facturar",
 "Factures dupliquées :": "Facturas duplicadas :",
 "Factures dupliquées supprimées": "Facturas duplicadas eliminadas",
 "Factures en cours": "Facturas en curso",
 "Factures liées": "Facturas vinculadas",
 "Factures émises TTC": "Facturas emitidas TTC",
 "Facturé ailleurs": "Facturado en otro lugar",
 "Fenêtre étendue": "Ventana ampliada",
 "Fenêtre étendue automatiquement : écritures antérieures à la dernière période incluses (exercice scindé)": "Ventana ampliada automáticamente : asientos anteriores al último periodo incluidos (ejercicio dividido)",
 "Filtrer :": "Filtrar :",
 "Forcer l'édition (écriture FEC verrouillée)": "Forzar la edición (asiento FEC bloqueado)",
 "Format CSV": "Formato CSV",
 "Fournisseurs récurrents non catégorisés — créez une règle en un clic, puis « Reconstruire la comptabilité » pour l'appliquer.": "Proveedores recurrentes no categorizados — cree una regla en un clic y luego «Reconstruir la contabilidad» para aplicarla.",
 "Fusionner": "Fusionar",
 "Fusionner plusieurs exercices en un exercice exceptionnel": "Fusionar varios ejercicios en un ejercicio excepcional",
 "Fusionner vers un autre patient": "Fusionar con otro paciente",
 "Fusion…": "Fusión…",
 "Gestion des immobilisations": "Gestión de inmovilizado",
 "Glissez un relevé CSV ici (ou": "Arrastre aquí un extracto CSV (o",
 "Génère et conserve les rapports agrégés de transactions B2C exigés par la DGFiP (réforme facturation électronique 2027). Téléchargez le CSV pour vérification ou le XML pour transmission au PPF/PDP.": "Genera y conserva los informes agregados de transacciones B2C exigidos por la DGFiP (reforma de facturación electrónica 2027). Descargue el CSV para verificación o el XML para transmisión al PPF/PDP.",
 "Génération automatique des écritures (Phase 2)": "Generación automática de los asientos (Fase 2)",
 "Génération du PDF…": "Generación del PDF…",
 "Génération journal BQ depuis Qonto": "Generación del libro BQ desde Qonto",
 "Génération…": "Generación…",
 "Générer BQ": "Generar BQ",
 "Générer les PDF au format Factur-X (PDF/A-3 + XML CII)": "Generar los PDF en formato Factur-X (PDF/A-3 + XML CII)",
 "Générer maintenant": "Generar ahora",
 "Générer un rapport": "Generar un informe",
 "Générez un mot de passe sur": "Genere una contraseña en",
 "Généré": "Generado",
 "Généré le": "Generado el",
 "Gérez les apports, retraits, remboursements et intérêts de chaque associé (sous-comptes 455xxx).": "Gestione las aportaciones, retiradas, reembolsos e intereses de cada socio (subcuentas 455xxx).",
 "Gérez vos consultations et facturez en un clic.": "Gestione sus consultas y facture en un clic.",
 "HT d'acquisition :": "HT de adquisición :",
 "HT de CA en double": "HT de CA duplicado",
 "Heure": "Hora",
 "Historique des rapports": "Historial de informes",
 "Horodatage": "Marca de tiempo",
 "Ici, mettez votre": "Aquí, introduzca su",
 "Identifiants Qonto manquants (Paramètres → APIs).": "Faltan las credenciales de Qonto (Configuración → APIs).",
 "Ignorées": "Ignoradas",
 "Immobilisations corporelles": "Inmovilizado material",
 "Immobilisations financières": "Inmovilizado financiero",
 "Immobilisations incorporelles": "Inmovilizado intangible",
 "Impact 512x": "Impacto 512x",
 "Impact :": "Impacto :",
 "Impact CA": "Impacto CA",
 "Import": "Importar",
 "Import en cours…": "Importación en curso…",
 "Importer depuis le FEC": "Importar desde el FEC",
 "Importer les immobilisations depuis le FEC": "Importar el inmovilizado desde el FEC",
 "Importer un FEC": "Importar un FEC",
 "Importé Comptalib (FEC)": "Importado de Comptalib (FEC)",
 "Impossible de charger les données.": "No se han podido cargar los datos.",
 "Inactif": "Inactivo",
 "Inclure les exercices clôturés": "Incluir los ejercicios cerrados",
 "Inclut toutes les factures B2C (patients non-entreprises) validées ou payées dans la période, net des avoirs.": "Incluye todas las facturas B2C (pacientes no empresas) validadas o pagadas en el periodo, netas de los abonos.",
 "Intitulé": "Denominación",
 "Intitulé du compte": "Denominación de la cuenta",
 "Intérêts servis": "Intereses abonados",
 "Invalides (TTC ≤ 0)": "Inválidas (TTC ≤ 0)",
 "Invité": "Invitado",
 "Job : Relances automatiques d'impayés": "Tarea : Recordatorios automáticos de impagos",
 "Job : Synchro Qonto (30 derniers jours)": "Tarea : Sincronización Qonto (últimos 30 días)",
 "Joindre des photos ou PDF (reçus, factures…) à cette entrée.": "Adjunte fotos o PDF (tickets, facturas…) a esta entrada.",
 "Joindre une facture déjà émise": "Adjuntar una factura ya emitida",
 "Justif.": "Justific.",
 "Justificatif": "Justificante",
 "Justificatifs": "Justificantes",
 "Justificatifs (facture d'achat, photo…)": "Justificantes (factura de compra, foto…)",
 "Justificatifs Qonto (achats)": "Justificantes Qonto (compras)",
 "L'associé doit à l'entreprise": "El socio debe a la empresa",
 "L'exercice restera ouvert.": "El ejercicio permanecerá abierto.",
 "L'exercice sera clôturé (immuable). Action sensible et auditée.": "El ejercicio se cerrará (inmutable). Acción sensible y auditada.",
 "La même catégorisation (compte + TVA) sera appliquée au montant total de chaque transaction sélectionnée, et l'écriture BQ sera générée immédiatement.": "La misma categorización (cuenta + TVA) se aplicará al importe total de cada transacción seleccionada, y el asiento BQ se generará inmediatamente.",
 "Lancer Qonto maintenant": "Iniciar Qonto ahora",
 "Lancer l'audit": "Iniciar la auditoría",
 "Lancer la synchronisation": "Iniciar la sincronización",
 "Lancer relances maintenant": "Iniciar recordatorios ahora",
 "Le XML est embarqué dans le PDF/A-3 via la librairie": "El XML está incrustado en el PDF/A-3 mediante la biblioteca",
 "Les RDV ≤ cette date apparaîtront en lecture seule avec le badge « 🔒 Facturé ailleurs ».": "Las citas ≤ esta fecha aparecerán en modo de solo lectura con la etiqueta « 🔒 Facturado en otro sitio ».",
 "Les collaborateurs se connectent par e-mail / mot de passe. Leurs actions sensibles (factures, écritures, rapprochements) passent par l'onglet": "Los colaboradores se conectan por e-mail / contraseña. Sus acciones sensibles (facturas, asientos, conciliaciones) pasan por la pestaña",
 "Les deux": "Ambos",
 "Les factures avec le même numéro déjà présent sont ignorées.": "Las facturas con el mismo número ya presente se ignoran.",
 "Les factures et l'historique seront transférés. Les factures validées conservent leur snapshot.": "Las facturas y el historial se transferirán. Las facturas validadas conservan su snapshot.",
 "Les factures rapprochées avec cette transaction sont proposées en premier. Son PDF sera attaché comme justificatif.": "Las facturas conciliadas con esta transacción se proponen en primer lugar. Su PDF se adjuntará como justificante.",
 "Les transactions « en attente d'annotation » ne créent aucune écriture : elles restent visibles dans la file « Transactions à annoter » jusqu'à ce que vous les catégorisiez (règle ou ventilation).": "Las transacciones « en espera de anotación » no crean ningún asiento: permanecen visibles en la cola « Transacciones por anotar » hasta que las categorice (regla o distribución).",
 "Lettrage": "Casación",
 "Libellé (optionnel)": "Concepto (opcional)",
 "Libellé compte": "Concepto de la cuenta",
 "Libellé de l'écriture": "Concepto del asiento",
 "Libellé du mouvement": "Concepto del movimiento",
 "Lier": "Vincular",
 "Lier / Créer": "Vincular / Crear",
 "Lier un patient au rendez-vous": "Vincular un paciente a la cita",
 "Ligne vide": "Línea vacía",
 "Lignes": "Líneas",
 "Lignes orange : le mois cumule du CA « VE » (factures) ET du CA « BQ » (annotations bancaires en 7xx) — risque de double comptage si ces annotations correspondent aux mêmes encaissements que les factures.": "Líneas naranjas: el mes acumula CA « VE » (facturas) Y CA « BQ » (anotaciones bancarias en 7xx) — riesgo de doble contabilización si estas anotaciones corresponden a los mismos cobros que las facturas.",
 "Liste limitée à 500 lignes. Utilisez les filtres pour affiner.": "Lista limitada a 500 líneas. Utilice los filtros para afinar.",
 "Livre": "Libro",
 "MINIMUM — En-tête uniquement (recommandé B2C)": "MÍNIMO — Solo encabezado (recomendado B2C)",
 "Manque": "Falta",
 "Mapping actif": "Mapeo activo",
 "Marquer payée": "Marcar pagada",
 "Masquer": "Ocultar",
 "Matcher FEC": "Emparejar FEC",
 "Mensuelle": "Mensual",
 "Mention légale": "Aviso legal",
 "Message (laisser vide pour le modèle)": "Mensaje (dejar en blanco para la plantilla)",
 "Mise au rebut": "Baja por desecho",
 "Mobilier : 120 / Matériel info : 36 / Logiciel : 12-36": "Mobiliario : 120 / Material informático : 36 / Software : 12-36",
 "Mode": "Modo",
 "Mode récupération": "Modo recuperación",
 "Modifier l'associé": "Modificar el socio",
 "Modifier l'immobilisation": "Modificar el inmovilizado",
 "Modifier la règle": "Modificar la regla",
 "Modifier le compte": "Modificar la cuenta",
 "Modifier le patient": "Modificar el paciente",
 "Modifier le service": "Modificar el servicio",
 "Modèle Corps": "Plantilla del cuerpo",
 "Modèle Objet": "Plantilla del asunto",
 "Modèle de relance d'impayé": "Plantilla de recordatorio de impago",
 "Mois (opt.)": "Mes (opcional)",
 "Mois en cours": "Mes en curso",
 "Mois précédent": "Mes anterior",
 "Montant (€)": "Importe (€)",
 "Montant HT (€)": "Importe HT (€)",
 "Montant TTC (€)": "Importe TTC (€)",
 "Montant TTC (€) — signé": "Importe TTC (€) — con signo",
 "Montant attendu :": "Importe esperado:",
 "Motif contrepartie": "Motivo contrapartida",
 "Motif contrepartie (optionnel)": "Motivo contrapartida (opcional)",
 "Motif libellé": "Motivo etiqueta",
 "Motif libellé (contient, insensible casse)": "Motivo etiqueta (contiene, sin distinción entre mayúsculas y minúsculas)",
 "Mouvement": "Movimiento",
 "Moyen": "Medio",
 "Méthode": "Método",
 "Mêmes colonnes que Finom. Sera utilisé pour rapprocher avec les factures Qonto et les nouvelles.": "Las mismas columnas que Finom. Se utilizará para conciliar con las facturas de Qonto y las nuevas.",
 "N-1 Net": "N-1 Neto",
 "Nb factures": "N.º de facturas",
 "Net": "Neto",
 "Nettoyage appliqué": "Limpieza aplicada",
 "Nettoyage…": "Limpieza…",
 "Nettoyer & régénérer": "Limpiar y regenerar",
 "Nettoyer (brouillons / annulées)": "Limpiar (borradores / anuladas)",
 "Nettoyer doublons FEC": "Limpiar duplicados FEC",
 "Nom du service": "Nombre del servicio",
 "Non applicable": "No aplicable",
 "Non rapprochées": "No conciliadas",
 "Non rapprochés uniquement": "Solo no conciliados",
 "Non recommandé pour une EURL à l'IS strict (compta d'engagement obligatoire).": "No recomendado para una EURL con IS estricto (contabilidad de devengo obligatoria).",
 "Non-honoré": "Impagado",
 "Note (optionnel)": "Nota (opcional)",
 "Notes (optionnel)": "Notas (opcional)",
 "Nouveau compte": "Nueva cuenta",
 "Nouveau service": "Nuevo servicio",
 "Nouvel associé": "Nuevo socio",
 "Nouvelle division": "Nueva división",
 "Nouvelle immobilisation": "Nuevo inmovilizado",
 "Nouvelle opération": "Nueva operación",
 "Nouvelle règle": "Nueva regla",
 "Nouvelle version disponible": "Nueva versión disponible",
 "Numérotation": "Numeración",
 "N° (PCG)": "Nº (PCG)",
 "N° TVA": "Nº TVA",
 "N° TVA :": "Nº TVA :",
 "N° TVA intracom.": "Nº TVA intracom.",
 "N°, rue, code postal, ville": "Nº, calle, código postal, ciudad",
 "OD miroir": "OD espejo",
 "Objet (laisser vide pour le modèle)": "Asunto (dejar vacío para la plantilla)",
 "Objet relance": "Asunto del recordatorio",
 "Origine": "Origen",
 "Ou rechercher un autre patient existant": "O buscar otro paciente existente",
 "Ouvert": "Abierto",
 "Ouvrir": "Abrir",
 "PDF FactureCab ignoré(s) ·": "PDF FactureCab ignorado(s) ·",
 "PNG, JPG ou WEBP — max 5 Mo. Format transparent recommandé pour le logo et le cachet.": "PNG, JPG o WEBP — máx. 5 Mo. Se recomienda formato transparente para el logo y el sello.",
 "Page": "Página",
 "Paiements enregistrés": "Pagos registrados",
 "Par mode de paiement": "Por método de pago",
 "Par taux de TVA": "Por tipo de TVA",
 "Passif": "Pasivo",
 "Patient": "Paciente",
 "Patient / Invité": "Paciente / Invitado",
 "Patient lié": "Paciente vinculado",
 "Patient potentiellement existant": "Paciente potencialmente existente",
 "Patients potentiellement existants": "Pacientes potencialmente existentes",
 "Payées": "Pagadas",
 "Perso": "Personal",
 "Plan d'amortissement": "Plan de amortización",
 "Plan d'amortissement non calculable — vérifiez la durée et le HT.": "Plan de amortización no calculable — compruebe la duración y el HT.",
 "Port": "Puerto",
 "Positif = entrée · Négatif = sortie": "Positivo = entrada · Negativo = salida",
 "Post-clôture": "Postcierre",
 "Pour chaque transaction rapprochée sans justificatif, attache automatiquement le PDF de sa facture FactureCab": "Para cada transacción conciliada sin justificante, adjunta automáticamente el PDF de su factura FactureCab",
 "Pour confirmer, tapez": "Para confirmar, escriba",
 "Pour la facturation médicale exonérée de TVA (CGI art. 261-4-1°), MINIMUM est suffisant et fiabilise les rejets PDP.": "Para la facturación médica exenta de TVA (CGI art. 261-4-1°), MINIMUM es suficiente y reduce los rechazos PDP.",
 "Pour réel simplifié → typiquement mensuelle (à confirmer DGFiP).": "Para réel simplifié → normalmente mensual (a confirmar con DGFiP).",
 "Pour vérifier un PDF Factur-X généré, vous pouvez utiliser": "Para verificar un PDF Factur-X generado, puede utilizar",
 "Priorité": "Prioridad",
 "Priorité (plus élevé = appliqué d'abord)": "Prioridad (cuanto mayor, antes se aplica)",
 "Prix HT": "Precio HT",
 "Prix HT (€)": "Precio HT (€)",
 "Prix de vente HT (€)": "Precio de venta HT (€)",
 "Probables (revue manuelle) :": "Probables (revisión manual) :",
 "Prochain n°": "Próx. n°",
 "Prochaine exécution Qonto": "Próxima ejecución Qonto",
 "Prochaine exécution Relances": "Próxima ejecución Recordatorios",
 "Profil Factur-X": "Perfil Factur-X",
 "Progression de votre clôture": "Progreso de su cierre",
 "Provisions pour risques et charges": "Provisiones para riesgos y cargas",
 "Pré-clôture": "Pre-cierre",
 "Prérequis :": "Requisitos:",
 "Préservés automatiquement :": "Conservados automáticamente:",
 "Préset PCG": "Preajuste PCG",
 "Prévisualisation génération BQ": "Vista previa de generación BQ",
 "Prévisualisation génération VE": "Vista previa de generación VE",
 "Prévisualiser": "Previsualizar",
 "Prévisualiser BQ": "Previsualizar BQ",
 "Prévisualiser l'AN": "Previsualizar el AN",
 "Purge appliquée": "Purgado aplicado",
 "Purger FEC": "Purgar FEC",
 "Purger les VE illégitimes": "Purgar las VE ilegítimas",
 "Purge…": "Purgado…",
 "Périodes & Export FEC": "Periodos y exportación FEC",
 "Périodes &amp; Export FEC": "Periodos &amp; Export FEC",
 "Périodicité": "Periodicidad",
 "Qonto (réel)": "Qonto (real)",
 "Qonto :": "Qonto:",
 "Qonto — Login API (organisation-slug)": "Qonto — Inicio de sesión API (organization-slug)",
 "Qonto — Secret API": "Qonto — Secreto API",
 "Qté": "Cant.",
 "RDV": "citas",
 "RDV mis à jour · $": "citas actualizadas · $",
 "Rafraîchir": "Actualizar",
 "Raison": "Motivo",
 "Raison du rebut (panne, obsolescence…)": "Razón de la baja (avería, obsolescencia…)",
 "Raison sociale": "Razón social",
 "Rapport": "Informe",
 "Rapprochement multiple — versement agrégé (Tap to Pay)": "Conciliación múltiple — abono agregado (Tap to Pay)",
 "Rapprocher": "Conciliar",
 "Rapprocher la transaction": "Conciliar la transacción",
 "Rapprochée(s) avec cette transaction": "Conciliada(s) con esta transacción",
 "Rapprochées": "Conciliadas",
 "Rattachement…": "Vinculación…",
 "Rattraper espèces": "Ajustar efectivo",
 "Rebuild couples (force)": "Reconstruir parejas (forzar)",
 "Rebut": "Baja",
 "Recalculer": "Recalcular",
 "Recharger": "Recargar",
 "Recherche prioritaire par email puis téléphone. Détection automatique des doublons à la création.": "Búsqueda prioritaria por email y luego por teléfono. Detección automática de duplicados al crear.",
 "Reconstruire les lignes Qonto": "Reconstruir las líneas Qonto",
 "Reconstruit les soldes d'ouverture depuis l'exercice précédent — logique identique à Comptalib : bilan (classes 1-5) reporté net par compte · résultat 6/7 soldé en 120000/129000 · un seul AN actif par exercice.": "Reconstruye los saldos de apertura desde el ejercicio anterior — lógica idéntica a Comptalib: balance (clases 1-5) trasladado neto por cuenta · resultados 6/7 saldados en 120000/129000 · un solo AN activo por ejercicio.",
 "Relancer": "Reintentar",
 "Relances auto": "Recordatorios automáticos",
 "Relances envoyées :": "Recordatorios enviados:",
 "Relevés bancaires": "Extractos bancarios",
 "Remboursement (l'entreprise rembourse)": "Reembolso (la empresa reembolsa)",
 "Remboursé": "Reembolsado",
 "Remise": "Descuento",
 "Remise à zéro": "Restablecer a cero",
 "Remplacer": "Reemplazar",
 "Remplacer et valider": "Reemplazar y validar",
 "Remplacer l'écriture existante": "Reemplazar el asiento existente",
 "Remplacer les transactions déjà comptabilisées (force)": "Reemplazar las transacciones ya contabilizadas (forzar)",
 "Rendez-vous du": "Cita del",
 "Rendez-vous prévus": "Citas previstas",
 "Renseignez le HT, la durée d'amortissement et les comptes PCG.": "Rellene el HT, la duración de amortización y las cuentas PCG.",
 "Renseignez votre": "Rellene su",
 "Reprenez votre historique Qonto et importez les transactions bancaires Finom/Qonto pour le rapprochement.": "Recupere su historial de Qonto e importe las transacciones bancarias de Finom/Qonto para la conciliación.",
 "Reprise 2025 (1 013,72 €)": "Regularización 2025 (1 013,72 €)",
 "Restaurer": "Restaurar",
 "Resynchroniser": "Resincronizar",
 "Retour aux factures": "Volver a las facturas",
 "Retour aux patients": "Volver a los pacientes",
 "Retrait (l'associé retire)": "Retirada (el socio retira)",
 "Revenus par source (comptes 7xxx)": "Ingresos por fuente (cuentas 7xxx)",
 "Rouvrir": "Reabrir",
 "Règle active": "Regla activa",
 "Règle existante": "Regla existente",
 "Règles de catégorisation automatique": "Reglas de categorización automática",
 "Réactiver": "Reactivar",
 "Récupération en cours…": "Recuperación en curso…",
 "Récupérer les justificatifs": "Recuperar los justificantes",
 "Réessayer": "Reintentar",
 "Réf. pièce": "Ref. justificante",
 "Référence Comptalib (balance)": "Referencia Comptalib (balance)",
 "Référence facture, etc.": "Referencia de factura, etc.",
 "Réglages : Serveur": "Ajustes : Servidor",
 "Régénération appliquée": "Regeneración aplicada",
 "Régénérer VE": "Regenerar VE",
 "Répartition par mois côté Qonto :": "Reparto por mes en Qonto :",
 "Répartition équilibrée": "Reparto equilibrado",
 "Réserve légale actuelle": "Reserva legal actual",
 "Résolues :": "Resueltas :",
 "Résultat :": "Resultado :",
 "Résultat N-1 (compte 120)": "Resultado N-1 (cuenta 120)",
 "Réussi": "Correcto",
 "SIREN (9 chiffres)": "SIREN (9 cifras)",
 "SIRET (14 chiffres)": "SIRET (14 cifras)",
 "Sans patient lié": "Sin paciente vinculado",
 "Scanner les factures suspectes": "Escanear las facturas sospechosas",
 "Scan…": "Escaneo…",
 "Score": "Puntuación",
 "Sens": "Sentido",
 "Service associé": "Servicio asociado",
 "Seules les factures émises à partir du": "Solo las facturas emitidas a partir del",
 "Si la sync API échoue, importez via CSV : invoice_number, date, client_name, client_email, client_phone, total_amount, status (paid/draft), payment_method, pdf_url.": "Si la sincronización de la API falla, importe mediante CSV: invoice_number, date, client_name, client_email, client_phone, total_amount, status (paid/draft), payment_method, pdf_url.",
 "Si vos factures Qonto importées avaient un mauvais découpage HT/TVA (bug corrigé), les VE actuelles sont fausses. Cette action": "Si sus facturas Qonto importadas tenían un reparto incorrecto HT/TVA (error corregido), los VE actuales son erróneos. Esta acción",
 "Si votre pratique est en": "Si su práctica está en",
 "Si vous avez importé un FEC de Comptalib qui contient déjà des encaissements": "Si ha importado un FEC de Comptalib que ya contiene cobros",
 "Signing secret": "Secreto de firma",
 "Simulation": "Simulación",
 "Simulation de nettoyage": "Simulación de limpieza",
 "Simulation doublons VE": "Simulación de duplicados VE",
 "Simulation factures dupliquées": "Simulación de facturas duplicadas",
 "Simuler": "Simular",
 "Simuler la purge": "Simular la purga",
 "Simuler la régénération": "Simular la regeneración",
 "Simuler la suppression FEC": "Simular la eliminación del FEC",
 "Simuler la suppression VE de": "Simular la eliminación VE de",
 "Simuler le backfill": "Simular el backfill",
 "Simuler le nettoyage": "Simular la limpieza",
 "Société (B2B)": "Empresa (B2B)",
 "Soit via le bouton ci-dessous, soit manuellement dans Calendly → Integrations → Webhooks.": "Ya sea mediante el botón de abajo, ya sea manualmente en Calendly → Integrations → Webhooks.",
 "Solde :": "Saldo :",
 "Solde Comptalib": "Saldo Comptalib",
 "Solde actuel": "Saldo actual",
 "Solde app": "Saldo de la app",
 "Solde caisse": "Saldo de caja",
 "Solde compte 411 (Clients)": "Saldo cuenta 411 (Clientes)",
 "Solde d'ouverture": "Saldo de apertura",
 "Solde généré": "Saldo generado",
 "Solde nul": "Saldo cero",
 "Sortie": "Salida",
 "Source": "Origen",
 "Source / Journal": "Origen / Diario",
 "Source: Qonto (non modifiable)": "Fuente: Qonto (no modificable)",
 "Sources": "Orígenes",
 "Sous-compte 455xxx": "Subcuenta 455xxx",
 "Splits 7xxx": "Repartos 7xxx",
 "Statuts factures": "Estados de las facturas",
 "Stocks et en-cours": "Existencias y trabajos en curso",
 "Stripe (paiements en ligne)": "Stripe (pagos en línea)",
 "Stripe — Clé API secrète": "Stripe — Clave API secreta",
 "Stripe — Secret du webhook": "Stripe — Secreto del webhook",
 "Suggestions de règles": "Sugerencias de reglas",
 "Suppression…": "Eliminación…",
 "Supprimer FEC": "Eliminar FEC",
 "Supprimer ce brouillon": "Eliminar este borrador",
 "Supprimer définitivement cette transaction": "Eliminar definitivamente esta transacción",
 "Supprimer les doublons exacts": "Eliminar los duplicados exactos",
 "Supprimer toutes les VE de": "Eliminar todas las VE de",
 "Supprimer toutes les divisions": "Eliminar todas las divisiones",
 "Sync Calendly": "Sincronizar Calendly",
 "Sync Qonto complète (entrées + sorties)": "Sincronización completa de Qonto (entradas + salidas)",
 "Synchronisation API": "Sincronización API",
 "Synchronisation en cours…": "Sincronización en curso…",
 "Synchronisation…": "Sincronización…",
 "Synchroniser": "Sincronizar",
 "Synchroniser Qonto": "Sincronizar Qonto",
 "Synchroniser Stripe": "Sincronizar Stripe",
 "Synchroniser Zettle maintenant": "Sincronizar Zettle ahora",
 "Synchroniser avec Calendly": "Sincronizar con Calendly",
 "Synchroniser depuis": "Sincronizar desde",
 "Synchro…": "Sincronización…",
 "Sélectionner le patient cible…": "Seleccionar al paciente de destino…",
 "Sélectionnez une période.": "Seleccione un período.",
 "Sélectionnez une transaction": "Seleccione una transacción",
 "Séparateur virgule, montants en EUR (1234.56 ou 1 234,56).": "Separador coma, importes en EUR (1234.56 o 1 234,56).",
 "Séparez les paragraphes par une ligne vide.": "Separe los párrafos con una línea en blanco.",
 "TLS (STARTTLS pour 587, SSL implicite pour 465)": "TLS (STARTTLS para 587, SSL implícito para 465)",
 "TOTAL JOURNAL :": "TOTAL DIARIO :",
 "TTC en trop": "TTC de más",
 "TTC en trop)": "TTC de más)",
 "TVA manuelle": "TVA manual",
 "Taux": "Tipo",
 "Terminé": "Terminado",
 "Test": "Prueba",
 "Test : envoyer à": "Prueba : enviar a",
 "Tester": "Probar",
 "Tester / Synchroniser Stripe": "Probar / Sincronizar Stripe",
 "Tester l'authentification Zettle": "Probar la autenticación de Zettle",
 "Tester le token": "Probar el token",
 "Tester une règle": "Probar una regla",
 "Total (I) Capitaux propres": "Total (I) Fondos propios",
 "Total Cumulé :": "Total acumulado :",
 "Total HT avant remise": "Total HT antes del descuento",
 "Total Mois :": "Total mes :",
 "Total des divisions :": "Total de las divisiones :",
 "Total général Actif": "Total general Activo",
 "Total général Passif": "Total general Pasivo",
 "Total renvoyé par Qonto :": "Total devuelto por Qonto :",
 "Totaux du poste sur la période :": "Totales de la cuenta en el período :",
 "Tous exercices": "Todos los ejercicios",
 "Tous journaux": "Todos los diarios",
 "Tous statuts": "Todos los estados",
 "Tout": "Todo",
 "Tout désélectionner": "Deseleccionar todo",
 "Tout effacer": "Borrar todo",
 "Toute votre facturation.": "Toda tu facturación.",
 "Toutes": "Todas",
 "Toutes actions": "Todas las acciones",
 "Toutes banques": "Todos los bancos",
 "Toutes catégorisations": "Todas las categorizaciones",
 "Toutes entités": "Todas las entidades",
 "Toutes les actions importantes sont tracées : création, modification, validation, envoi, paiement, fusion, rapprochement, exports.": "Todas las acciones importantes quedan registradas: creación, modificación, validación, envío, pago, fusión, conciliación, exportaciones.",
 "Toutes les transactions sont annotées": "Todas las transacciones están anotadas",
 "Toutes les transactions sont catégorisées ✓": "Todas las transacciones están categorizadas ✓",
 "Toutes sources": "Todas las fuentes",
 "Traiter": "Procesar",
 "Transactions concernées (": "Transacciones afectadas (",
 "Transmis": "Transmitido",
 "Transmis le": "Transmitido el",
 "Trimestre précédent": "Trimestre anterior",
 "Trimestrielle": "Trimestral",
 "Trésorerie réelle": "Tesorería real",
 "Type": "Tipo",
 "Type d'événement": "Tipo de evento",
 "Types d'événements Calendly": "Tipos de eventos de Calendly",
 "Téléphone :": "Teléfono :",
 "Téléverser": "Subir",
 "UUID OAuth de votre app Zettle": "UUID OAuth de tu app Zettle",
 "Un seul endroit.": "Un solo lugar.",
 "Un snapshot est automatiquement créé": "Se crea automáticamente una captura",
 "Une affectation existe déjà pour": "Ya existe una asignación para",
 "Unité": "Unidad",
 "Utilisateur": "Usuario",
 "Utiliser 411000 (règlement client) à la place": "Usar 411000 (liquidación de cliente) en su lugar",
 "Utilisez un": "Utiliza un",
 "VE (factures)": "VE (facturas)",
 "VE archivée(s),": "VE archivada(s),",
 "VE existante(s).": "VE existente(s).",
 "VE supprimable(s),": "VE eliminable(s),",
 "VE supprimable(s), ` + `$": "VE eliminable(s), ` + `$",
 "VE supprimée(s), $": "VE eliminada(s), $",
 "VE supprimée(s), ` + `$": "VE eliminada(s), ` + `$",
 "VNC (valeur nette comptable) :": "VNC (valor neto contable) :",
 "VNC fin d'exercice": "VNC al cierre del ejercicio",
 "Valeur résiduelle (€)": "Valor residual (€)",
 "Valeurs mobilières de placement": "Valores mobiliarios de colocación",
 "Valider l'affectation": "Validar la asignación",
 "Validées / Envoyées": "Validadas / Enviadas",
 "Ventilation modifiée": "Desglose modificado",
 "Ventilation modifiée — écriture régénérée ✓": "Desglose modificado — asiento regenerado ✓",
 "Ventilez le montant total en plusieurs catégories (ex. : Stripe = encaissement vente - frais).": "Distribuye el importe total en varias categorías (p. ej. : Stripe = cobro de venta - comisiones).",
 "Verrouillage facturation historique": "Bloqueo de facturación histórica",
 "Via règle": "Mediante regla",
 "Vide = mode": "Vacío = modo",
 "Virement interne : pas de TVA, pas d'impact P&L. La somme se contrebalancera avec la transaction sur l'autre compte.": "Transferencia interna : sin TVA, sin impacto en P&L. La suma se compensará con la transacción en la otra cuenta.",
 "Voir la facture associée à cet avoir.": "Ver la factura asociada a este abono.",
 "Voir toutes les factures": "Ver todas las facturas",
 "Volume (RDV)": "Volumen (citas)",
 "Volver a intentar": "Volver a intentar",
 "Vos clients reçoivent un PDF lisible": "Tus clientes reciben un PDF legible",
 "Vérifiez avant de créer un nouveau patient.": "Verifique antes de crear un nuevo paciente.",
 "Vérifiez vos écritures avant clôture.": "Verifique sus asientos antes del cierre.",
 "Webhook Calendly :": "Webhook de Calendly :",
 "Webhook Stripe :": "Webhook de Stripe :",
 "Zettle (terminal carte)": "Zettle (terminal de tarjeta)",
 "Zone TVA": "Zona TVA",
 "Zone dangereuse — Mode compta trésorerie": "Zone peligrosa — Modo contabilidad de tesorería",
 "absente(s) de la base": "ausente(s) de la base",
 "achats importés ($": "compras importadas ($",
 "associez chaque": "asocie cada",
 "au service correspondant de votre catalogue. Quand vous cliquez sur « Nouvelle facture » depuis une fiche patient, le brouillon est automatiquement pré-rempli avec le service mappé sur le dernier rendez-vous du patient.": "al servicio correspondiente de su catálogo. Cuando haga clic en «Nueva factura» desde la ficha de un paciente, el borrador se rellenará automáticamente con el servicio asignado a la última cita del paciente.",
 "au total": "en total",
 "aucun écart ✓": "sin discrepancia ✓",
 "brouillon": "borrador",
 "candidat(s) trouvé(s) ·": "candidato(s) encontrado(s) ·",
 "candidate(s).`,": "candidato(s).`,",
 "cession": "cesión",
 "cette écriture AN ($": "este asiento AN ($",
 "chaque nuit (heure de Paris), l'application synchronise automatiquement les transactions Qonto récentes et envoie les relances dues. Les jobs sont gérés en mémoire (APScheduler) — pas besoin de cron externe.": "cada noche (hora de París), la aplicación sincroniza automáticamente las transacciones recientes de Qonto y envía los recordatorios vencidos. Los trabajos se gestionan en memoria (APScheduler) — no hace falta un cron externo.",
 "charge 6xx": "cargo 6xx",
 "clôturé (ValidDate = $": "cerrado (ValidDate = $",
 "complété": "completado",
 "compta de trésorerie": "contabilidad de tesorería",
 "compte": "cuenta",
 "compte réel": "cuenta real",
 "compte$": "cuenta$",
 "compte(s) en écart · total |écart|": "cuenta(s) con discrepancia · total |discrepancia|",
 "comptes": "cuentas",
 "comptes ajoutés.$": "cuentas añadidas.$",
 "couple(s) détecté(s) · $": "pareja(s) detectada(s) · $",
 "credit": "crédito",
 "créditeur": "acreedor",
 "créditrices": "acreedoras",
 "créez un Personal Access Token dans Integrations → API & Webhooks. La synchronisation manuelle (Rendez-vous → Synchroniser) récupère les 12 derniers mois et 6 mois à venir.": "cree un Personal Access Token en Integrations → API & Webhooks. La sincronización manual (citas → Sincronizar) recupera los 12 últimos meses y los 6 meses siguientes.",
 "créé depuis le PDF : $": "creado a partir del PDF : $",
 "créée(s).": "creada(s).",
 "créées ·": "creadas ·",
 "créées · $": "creadas · $",
 "créées, $": "creadas, $",
 "cumul antérieur": "acumulado anterior",
 "dans": "en",
 "dans Réglages → Société avant de générer un rapport.": "en Ajustes → Empresa antes de generar un informe.",
 "dans Stripe → Developers → Webhooks → Add endpoint, pointez vers": "en Stripe → Developers → Webhooks → Add endpoint, apunte a",
 "date requise": "fecha requerida",
 "day": "día",
 "debit": "débito",
 "default": "predeterminado",
 "depuis ce PDF": "desde este PDF",
 "doit être monté une fois (App.js). */ import": "debe montarse una vez (App.js). */ import",
 "dotation(s) générée(s) sont en doublon avec votre FEC importé ($": "la(s) dotación(es) generada(s) está(n) duplicada(s) con su FEC importado ($",
 "doublon(s) supprimé(s). $": "duplicado(s) eliminado(s). $",
 "du FEC\\n` + ` • $": "del FEC\\n` + ` • $",
 "due et déductible simultanément (neutre).": "devengada y deducible simultáneamente (neutra).",
 "durée": "duración",
 "débiteur": "deudor",
 "déjà connue(s) — ignorée(s)": "ya conocida(s) — ignorada(s)",
 "déjà connue(s), $": "ya conocida(s), $",
 "déjà connue(s).$": "ya conocida(s).$",
 "déjà existante(s)$": "ya existente(s)$",
 "déjà existantes` + (d.uncategorized ? ` · $": "ya existentes` + (d.uncategorized ? ` · $",
 "déjà importé(s) ·": "ya importado(s) ·",
 "déjà payée — sera liée": "ya pagada — se vinculará",
 "déjà payée(s) simplement liée(s) — total $": "ya pagada(s) simplemente vinculada(s) — total $",
 "déliée$": "desvinculada$",
 "détectée": "detectada",
 "en « E-mail expéditeur » — c'est lui que verront vos patients": "en «E-mail remitente» — es el que verán sus pacientes",
 "en « Identifiant SMTP » et son app password en « Mot de passe »": "en «Identificador SMTP» y su app password en «Contraseña»",
 "enregistré · VNC $": "registrado · VNC $",
 "erreur(s)": "error(es)",
 "erreur(s) :": "error(es) :",
 "erreur(s) — voir console pour détails.": "error(es) — vea la consola para más detalles.",
 "erreur(s). $": "error(es). $",
 "erreurs": "errores",
 "et affichent HT=0 / TVA=0 dans l'interface. Cette étape reconstruit une ligne synthétique à partir de": "y muestran HT=0 / TVA=0 en la interfaz. Este paso reconstruye una línea sintética a partir de",
 "et collez-la ici. La synchro importe les achats récents (paiements terminal carte) pour rapprochement.": "y péguela aquí. La sincronización importa las compras recientes (pagos con terminal de tarjeta) para su conciliación.",
 "et créé$": "y creada$",
 "et validez le lien reçu": "y valide el enlace recibido",
 "ex. Encaissements patients 2026": "p. ej. Cobros de pacientes 2026",
 "ex. GOOGLE WORKSPACE": "p. ej. GOOGLE WORKSPACE",
 "ex. M. Dupont — particulier": "p. ej. Sr. Dupont — particular",
 "ex. Ventes de marchandises TVA 20%": "p. ej. Ventas de mercancías TVA 20%",
 "ex. Victor Loher": "p. ej. Victor Loher",
 "ex. google": "p. ej. google",
 "ex. iPad Pro 12.9 (cabinet)": "p. ej. iPad Pro 12.9 (consulta)",
 "ex: prod_xxxxxxxxxxxxxxxxxxxxxxxxx": "ej: prod_xxxxxxxxxxxxxxxxxxxxxxxxx",
 "ex: votre-eurl-1234": "ej: votre-eurl-1234",
 "exacte(s) (": "exacta(s) (",
 "export": "exportar",
 "export.invoices_csv": "exportar.facturas_csv",
 "eyJ… JWT généré dans my.zettle.com": "eyJ… JWT generado en my.zettle.com",
 "factur-x": "Factur-X",
 "facture": "factura",
 "facture(s) (": "factura(s) (",
 "facture(s) acquittée(s) — total $": "factura(s) pagada(s) — total $",
 "facture(s) attachée(s) sur $": "factura(s) adjuntada(s) en $",
 "facture(s) dupliquée(s) supprimée(s), $": "factura(s) duplicada(s) eliminada(s), $",
 "facture(s) importée(s)": "factura(s) importada(s)",
 "facture(s) rapprochée(s), dont $": "factura(s) conciliada(s), de las cuales $",
 "facture(s) sans lignes,": "factura(s) sin líneas,",
 "facture(s) trouvée(s) pour « $": "factura(s) encontrada(s) para « $",
 "facture(s) · CA en trop": "factura(s) · CA en exceso",
 "facture(s) — CA en trop": "factura(s) — CA en exceso",
 "facture(s), CA en trop $": "factura(s), CA en exceso $",
 "factures ne sont jamais touchées": "las facturas nunca se modifican",
 "factures ·": "facturas ·",
 "factures · $": "facturas · $",
 "faible": "bajo",
 "finally": "por fin",
 "gain": "ganancia",
 "ghost": "fantasma",
 "groupe(s)": "grupo(s)",
 "groupe(s) exact(s) ` + `($": "grupo(s) exacto(s) ` + `($",
 "groupe(s) ·": "grupo(s) ·",
 "groupe(s), $": "grupo(s), $",
 "généré : $": "generado : $",
 "hors filtre. Depuis $": "fuera de filtro. Desde $",
 "ignorée(s)": "ignorada(s)",
 "ignorée(s).": "ignorada(s).",
 "ignorée(s)` + (r.data.uncategorized ? `, $": "ignorada(s)` + (r.data.uncategorized ? `, $",
 "ignorées ·": "ignoradas ·",
 "immo importée(s), $": "inmovilizado importado(s), $",
 "immo$": "inmovilizado$",
 "immobilisation(s) déjà dans le registre (non listées)": "inmovilización(es) ya en el registro (no listadas)",
 "import": "importar",
 "import.bank_transactions": "importar.transacciones_bancarias",
 "import.qonto_invoices": "importar.facturas_qonto",
 "importation (445666 / 445204)": "importación (445666 / 445204)",
 "importée(s), $": "importada(s), $",
 "instantanée": "instantánea",
 "intracommunautaire (445662 / 445200)": "intracomunitario (445662 / 445200)",
 "invoice": "factura",
 "invoice.create": "factura.crear",
 "invoice.email": "factura.correo",
 "invoice.validate": "factura.validar",
 "italic": "cursiva",
 "italic=": "cursiva=",
 "item=": "elemento=",
 "justificatif(s) téléchargé(s)": "justificante(s) descargado(s)",
 "label=": "etiqueta=",
 "le validateur officiel FNFE-MPE": "el validador oficial FNFE-MPE",
 "ligne(s) créée(s)": "línea(s) creada(s)",
 "ligne(s) supprimées` + (resetBank ? `, $": "línea(s) eliminada(s)` + (resetBank ? `, $",
 "ligne(s) ·": "línea(s) ·",
 "ligne(s),": "línea(s),",
 "ligne(s), ` + `$": "línea(s), ` + `$",
 "ligne(s), impact CA": "línea(s), impacto CA",
 "lignes dans le journal": "líneas en el diario",
 "lignes · D": "líneas · D",
 "lignes) ` + `depuis l'exercice $": "líneas) ` + `desde el ejercicio $",
 "lignes). Cliquez maintenant « Générer BQ ».`,": "líneas). Haga clic ahora en «Generar BQ».`,",
 "line=": "línea=",
 "lines: []": "líneas: []",
 "liée(s), $": "vinculada(s), $",
 "loading=": "cargando=",
 "locked=": "bloqueado=",
 "machine-readable.": "legible por máquina.",
 "mais l'écriture VE correspondante n'a pas été générée dans le journal des ventes.": "pero el asiento VE correspondiente no se ha generado en el diario de ventas.",
 "margin=": "margen=",
 "maxLength=": "longitudMáxima=",
 "minTickGap=": "intervaloMínTicks=",
 "mises à jour, $": "actualizaciones, $",
 "month": "mes",
 "mot de passe d'application": "contraseña de aplicación",
 "moyen": "medio",
 "non comptabilisée": "no contabilizada",
 "nouveau(x), $": "nuevo(s), $",
 "nouvelle(s), $": "nueva(s), $",
 "outline": "esquema",
 "paiement(s) en espèces sans écriture de caisse :\n\n$": "pago(s) en efectivo sin asiento de caja :\n\n$",
 "paiements importés ($": "pagos importados ($",
 "par": "por",
 "parcourir": "examinar",
 "patient": "paciente",
 "patient.create": "paciente.crear",
 "patient.merge": "paciente.fusionar",
 "patient.update": "paciente.actualizar",
 "payment": "pago",
 "payment.create": "pago.crear",
 "periods=": "periodos=",
 "perte": "pérdida",
 "pour $": "por $",
 "pour créer les rendez-vous en temps réel, abonnez votre app à l'URL :": "para crear las citas en tiempo real, suscribe tu app a la URL:",
 "pour obtenir un Client ID. Puis dans votre compte Zettle (": "para obtener un Client ID. Después, en tu cuenta Zettle (",
 "pour restaurer l'affichage.": "para restaurar la visualización.",
 "pour un compte": "para una cuenta",
 "produit 7xx": "producto 7xx",
 "puis les recrée depuis les factures actuelles avec la logique corrigée (support des champs Qonto": "y luego las vuelve a crear a partir de las facturas actuales con la lógica corregida (compatibilidad con los campos Qonto",
 "rebut": "rechazo",
 "reconstruite(s),": "reconstruida(s),",
 "recréée(s)` + (skipped ? `, $": "recreada(s)` + (skipped ? `, $",
 "relance(s) envoyée(s), $": "recordatorio(s) enviado(s), $",
 "rendez-vous": "citas",
 "renseignez SIRET / SIREN / Adresse complète dans l'onglet « Société », et pour vos clients pro, cochez « Client professionnel » + SIRET dans leur fiche.": "introduce SIRET / SIREN / dirección completa en la pestaña «Sociedad», y para tus clientes profesionales, marca «Cliente profesional» + SIRET en su ficha.",
 "restant": "restante",
 "return": "volver",
 "récupérez votre Login (slug d'organisation) et Secret depuis Qonto → Paramètres → Intégrations → API. La synchronisation importe toutes les transactions": "recupera tu Login (slug de organización) y Secret desde Qonto → Ajustes → Integraciones → API. La sincronización importa todas las transacciones",
 "récupérez votre clé API depuis": "recupera tu clave API desde",
 "réparée(s) — lignes et montants HT/TVA complétés": "corregida(s) — líneas e importes HT/TVA completados",
 "self-hosted app": "aplicación autoalojada",
 "sera$": "será$",
 "settings": "parámetros",
 "si nécessaire, puis cochez ce que vous souhaitez importer.": "si es necesario, luego marque lo que desea importar.",
 "signin_with": "iniciar sesión con",
 "sk_live_… ou sk_test_…": "sk_live_… o sk_test_…",
 "sont comptabilisées (date pivot configurée).": "se contabilizan (fecha pivote configurada).",
 "sortie(s) détectée(s)\\n • $": "salida(s) detectada(s)\\n • $",
 "supprimer toutes les écritures VE de cet exercice": "eliminar todos los asientos VE de este ejercicio",
 "supprimée(s),": "eliminada(s),",
 "supprimée(s). ` + `Snapshot : $": "eliminada(s). ` + `Snapshot: $",
 "sur votre compte Google": "en su cuenta de Google",
 "séance": "sesión",
 "sélectionnée": "seleccionada",
 "test": "prueba",
 "transaction": "transacción",
 "transaction$": "transacción$",
 "transaction(s) Qonto absente(s) de la base pour $": "transacción(es) de Qonto ausente(s) de la base para $",
 "transaction(s) avec justificatif côté Qonto ·": "transacción(es) con justificante en Qonto ·",
 "transaction(s) avec justificatif ·": "transacción(es) con justificante ·",
 "transaction(s) bancaire(s) et $": "transacción(es) bancaria(s) y $",
 "transaction(s) concernée(s).": "transacción(es) afectada(s).",
 "transaction(s) converties en 411000 — $": "transacción(es) convertidas en 411000 — $",
 "transaction(s) déjà comptabilisée(s) via FEC sur": "transacción(es) ya contabilizada(s) vía FEC en",
 "transaction(s) importée(s) mais NON comptabilisée(s) pour un impact de $": "transacción(es) importada(s) pero NO contabilizada(s) para un impacto de $",
 "transaction(s) non catégorisée(s),": "transacción(es) no categorizada(s),",
 "transaction(s) ·": "transacción(es) ·",
 "transaction(s))` + (g.suggested ? ` — compte suggéré $": "transacción(es))` + (g.suggested ? ` — cuenta sugerida $",
 "transaction(s), $": "transacción(es), $",
 "transaction(s).`,": "transacción(es).`,",
 "transaction=": "transacción=",
 "transactions Qonto analysées · exercice": "transacciones Qonto analizadas · ejercicio",
 "try": "probar",
 "tx déliées, $": "tx desvinculadas, $",
 "type d'événement Calendly": "tipo de evento de Calendly",
 "type=": "tipo=",
 "téléchargé(s)": "descargado(s)",
 "update(i,": "actualizar(i,",
 "updateField(": "actualizarCampo(",
 "updateSplit(i,": "actualizarSplit(i,",
 "validation en 2 étapes": "validación en 2 pasos",
 "ventilation(s) supprimées` : `, $": "ventilación(es) eliminada(s)` : `, $",
 "vide = 2 ans": "vacío = 2 años",
 "vide = 2 ans par défaut": "vacío = 2 años por defecto",
 "warn": "advertencia",
 "warn=": "advertencia=",
 "year=": "año=",
 "zone=": "zona=",
 "« Envoyer des e-mails en tant que »": "«Enviar correos electrónicos como »",
 "« Traiter comme un alias »": "«Tratar como un alias »",
 "À catégoriser": "Por categorizar",
 "À chaque validation de facture (ou régénération PDF), le moteur calcule un XML CII conforme.": "En cada validación de factura (o regeneración de PDF), el motor calcula un XML CII conforme.",
 "À faire": "Por hacer",
 "À générer": "Por generar",
 "À ignorer :": "Ignorar:",
 "À importer :": "Por importar:",
 "À lier": "Vincular",
 "À revoir avant clôture d'exercice.": "A revisar antes del cierre del ejercicio.",
 "À traiter": "Por tratar",
 "À venir": "Próximamente",
 "À-nouveaux (AN) — ouverture d'exercice": "A nuevos (AN) — apertura de ejercicio",
 "Écarts uniquement": "Solo diferencias",
 "Échéance": "Vencimiento",
 "Écriture d'origine :": "Asiento de origen:",
 "Écriture déjà présente": "Asiento ya presente",
 "Écriture désactivée": "Asiento desactivado",
 "Écriture réactivée": "Asiento reactivado",
 "Écritures ACTIVES": "Asientos ACTIVOS",
 "Écritures ARCHIVÉES (hors livres)": "Asientos ARCHIVADOS (fuera de los libros)",
 "Écritures VE dupliquées :": "Asientos VE duplicados:",
 "Écritures VE illégitimes (antérieures au": "Asientos VE ilegítimos (anteriores al",
 "Écritures manuelles non clôturées": "Asientos manuales no cerrados",
 "Équilibre des écritures": "Equilibrio de los asientos",
 "Équilibré": "Cuadrado",
 "État": "Estado",
 "État du planificateur": "Estado del planificador",
 "à annoter": "para anotar",
 "à catégoriser": "para categorizar",
 "à comparer aux totaux Comptalib": "para comparar con los totales de Comptalib",
 "à compléter": "para completar",
 "à traiter": "para procesar",
 "à-nouveaux": "asientos de apertura",
 "écr. ·": "asiento ·",
 "écriture": "asiento",
 "écriture$": "asiento$",
 "écriture(s)": "asiento(s)",
 "écriture(s) FEC $": "asiento(s) FEC $",
 "écriture(s) FEC (Comptalib) → archivées (récupérables)\\n` + ` • $": "asiento(s) FEC (Comptalib) → archivados (recuperables)\\n` + ` • $",
 "écriture(s) VE antérieure(s) au $": "asiento(s) VE anterior(es) al $",
 "écriture(s) VE ont été générées pour des factures émises avant le": "se han generado asiento(s) VE para facturas emitidas antes del",
 "écriture(s) VE/BQ générées → recréées proprement\\n` + ` • $": "asiento(s) VE/BQ generados → recreados correctamente\\n` + ` • $",
 "écriture(s) archivée(s) (snapshot": "asiento(s) archivado(s) (snapshot",
 "écriture(s) créée(s), $": "asiento(s) creado(s), $",
 "écriture(s) de caisse créée(s)` + (r.data.skipped_closed_or_zero ? ` · $": "asiento(s) de caja creado(s)` + (r.data.skipped_closed_or_zero ? ` · $",
 "écriture(s) de dotation analysée(s) ·": "asiento(s) de dotación analizado(s) ·",
 "écriture(s) et $": "asiento(s) y $",
 "écriture(s) supprimable(s), ` + `$": "asiento(s) eliminable(s), ` + `$",
 "écriture(s) supprimée(s),": "asiento(s) eliminado(s),",
 "écriture(s),": "asiento(s),",
 "écriture(s), ` + `$": "asiento(s), ` + `$",
 "écritures FEC archivées ($": "asientos FEC archivados ($",
 "écritures VE pour la période $": "asientos VE para el período $",
 "écritures créées, $": "asientos creados, $",
 "écritures déplacées dans l'exercice $": "asientos movidos al ejercicio $",
 "écritures « À nouveaux » (AN) — reports de solde — et « Opérations Diverses » (OD) — distribution des bénéfices, régularisation compte courant associé, etc.": "asientos « A nuevos » (AN) — traspasos de saldo — y « Operaciones Diversas » (OD) — distribución de beneficios, regularización de cuenta corriente asociada, etc.",
 "épargnée(s) (exercice clôturé)": "ahorrada(s) (ejercicio cerrado)",
 "étapes terminées": "etapas completadas",
 "— Aucun (saisie manuelle) —": "— Ninguno (introducción manual) —",
 "— Aucun —": "— Ninguno —",
 "— Choisir —": "— Elegir —",
 "— ou coller le texte —": "— o pegar el texto —",
 "— réimporte les factures déjà présentes et enrichit les enregistrements existants avec les données Qonto (URL PDF, statut, ID Qonto). Utile après une sync partielle.": "— vuelve a importar las facturas ya presentes y enriquece los registros existentes con los datos de Qonto (URL PDF, estado, ID de Qonto). Útil después de una sincronización parcial.",
 "— vous pourrez restaurer en 1 clic si besoin.": "— podrás restaurarlo en 1 clic si hace falta.",
 "€ (montant fixe)": "€ (importe fijo)",
 "€ déduits du total HT": "€ deducidos del total HT",
 "⚠ Une VNC non nulle sera comptabilisée comme charge exceptionnelle au compte 675.": "⚠ Una VNC no nula se contabilizará como gasto excepcional en la cuenta 675.",
 "⚠️ Deux AN actifs pour le même exercice : risque de double comptage !": "⚠️ Dos AN activos para el mismo ejercicio: ¡riesgo de doble contabilización!",
 "⚠️ Risque de CA compté 2×": "⚠️ Riesgo de CA contabilizado 2×",
 "✓ Combinaison exacte détectée et pré-cochée — vérifiez puis validez.": "✓ Combinación exacta detectada y preseleccionada — verifica y luego valida.",
 "✓ Règle matchée :": "✓ Regla coincidente :",
 "✓ Équilibré": "✓ Cuadrado"
};
